import script from "./AdminEditVacancyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEditVacancyHeader.vue?vue&type=script&setup=true&lang=js"

import "./AdminEditVacancyHeader.vue?vue&type=style&index=0&id=58a20b01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a20b01"]])

export default __exports__